(function(){
  function init(){
    var items=document.querySelectorAll('.accordion-item');
    items.forEach(function(item){
      item.style.height='auto';
      var toggle=item.querySelector('.accordion-toggle');
      if(!toggle||toggle.dataset.cbBound)return;
      toggle.dataset.cbBound='1';
      toggle.addEventListener('click',function(e){
        e.preventDefault();
        var open=item.classList.contains('cb-open');
        // close siblings in same wrapper for classic accordion feel
        var parent=item.parentNode;
        if(parent) parent.querySelectorAll('.accordion-item.cb-open').forEach(function(o){ if(o!==item)o.classList.remove('cb-open'); });
        item.classList.toggle('cb-open', !open);
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,800);
})();
